// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { createTypedReducerWithImmer } from "@insite/client-framework/Common/CreateTypedReducer";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { AnyAction, reducers } from "@insite/client-framework/Store/Reducers";
import { CategoryModel } from "@insite/client-framework/Types/ApiModels";
import { Draft } from "immer";

export type FeaturesCategoriesState = {
    views: {
        [key: string]: {
            categories: CategoryModel[];
            loading: boolean;
        };
    };
};

const initialXProductCategoriesState: FeaturesCategoriesState = { views: {} };

const xProductCategories = createTypedReducerWithImmer(initialXProductCategoriesState, {
    "xProductCategories/StartLoading": (draft: Draft<FeaturesCategoriesState>, action: { key: string }) => {
        draft.views[action.key] = {
            categories: [],
            loading: true,
        };
    },
    "xProductCategories/updateCategories": (
        draft: Draft<FeaturesCategoriesState>,
        action: { categories: CategoryModel[]; key: string },
    ) => {
        if (!draft.views[action.key]) {
            draft.views[action.key] = {
                categories: [],
                loading: true,
            };
        }
        draft.views[action.key].categories = action.categories;
    },
    "xProductCategories/CompleteLoading": (draft: Draft<FeaturesCategoriesState>, action: { key: string }) => {
        draft.views[action.key].loading = false;
    },
});

(reducers as any).xProductCategories = xProductCategories;

export type xProductCategoriesState = {
    xProductCategories: FeaturesCategoriesState;
} & ApplicationState;

type xProductCategoriesReducers = {
    tabs: typeof xProductCategories;
};

export type xProductCategoriesActions =
    | Parameters<xProductCategoriesReducers[keyof xProductCategoriesReducers]>[1]
    | AnyAction;
